import styled from 'styled-components';

export const SidebarContainer = styled.div`
  position: fixed;
  left: 0;
  bottom: 80px;
  transform: none;
  background-color: transparent;
  padding: ${({ theme }) => theme.spacing.sm};
  z-index: 999;

  @media (max-width: 768px) {
    left: 10px;
    bottom: auto;
    top: 55%;
    transform: translateY(-50%);
    width: auto;
    background-color: transparent;
    padding: ${({ theme }) => theme.spacing.xs};
    box-shadow: none;
    border-radius: 0;
  }
`;

export const SocialList = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing.sm};

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: flex-start;
  }
`;

export const SocialLink = styled.a`
  color: ${({ theme }) => theme.colors.text.secondary};
  font-size: 1.5rem;
  padding: ${({ theme }) => theme.spacing.xs};
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease;
  border-radius: ${({ theme }) => theme.borderRadius.small};

  &:hover {
    color: ${({ theme }) => theme.colors.primary};
    background-color: ${({ theme }) => theme.colors.surface.light};
    transform: translateX(5px);
  }

  @media (max-width: 768px) {
    &:hover {
      transform: translateY(-5px);
    }
  }
`;
